import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea1261e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrap",
  id: "login"
}
const _hoisted_2 = {
  class: "l-container",
  id: "js-container"
}
const _hoisted_3 = { class: "login-section" }
const _hoisted_4 = {
  key: 0,
  autocomplete: "off"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo-large" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "/assets/img/logo-large.svg"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caution" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "会場識別コード"),
  /*#__PURE__*/_createTextVNode("を入力して「次へ」ボタンをください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "会場識別コード"),
  /*#__PURE__*/_createTextVNode("はJET CBTテスト管理画面で確認してください。団体コードとは異なります。 ")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次へ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "secondary speed-caution" }, "※１人あたり０.１Mbps以上必要です", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "confirm-message" }
const _hoisted_15 = { class: "site-code" }
const _hoisted_16 = { class: "site-name" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン画面を表示する", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "戻る", -1))
const _hoisted_23 = [
  _hoisted_22
]

import {ref, inject} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { examKey } from "@/main";
import training from "@/pages/exam/Training.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteLogin',
  emits: ['overridePageName'],
  setup(__props) {

const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const error = ref('');
const authCode = ref('');
const siteCode = ref('');
const siteName = ref('');
const cbtCode = ref('');
const confirm = ref(false);

const official = exam?.isOfficial();

const onNext = async () => {
  if (!exam) return;
  try {
    const site = await exam.siteLogin(authCode.value);
    if (site.code == null) {
      error.value = "会場識別コードが正しくありません";
      return;
    }
    siteCode.value = site.code;
    siteName.value = site.name;
    cbtCode.value = site.cbtCode;
    confirm.value = true;
  }
  catch(e) {
    error.value = e.message;
  }
}
const onLogin = async () => {
  if (!exam) return;
  exam.startFullScreen();
  await router.replace('/cbt/' + cbtCode.value);
}
const onSpeecCheck = async () => {
  window.open('https://fast.com/ja/', '_blank', 'noopener,noreferrer');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["l-wrap__inner", {'bg-color':training}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(official))
            ? (_openBlock(), _createElementBlock("form", _hoisted_4, [
                (!confirm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _hoisted_7,
                      (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        autocomplete: "off",
                        class: "m-input__text login-id",
                        placeholder: "会場識別コード",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((authCode).value = $event)),
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$refs.inputPassword.focus()), ["enter"])),
                        disabled: _ctx.demo
                      }, null, 40, _hoisted_9), [
                        [_vModelText, authCode.value]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "m-btn primary is-center",
                        onClick: onNext
                      }, _hoisted_11),
                      _createElementVNode("div", { class: "speed-check" }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "m-btn secondary is-center",
                          onClick: onSpeecCheck
                        }, "回線速度をチェックする")
                      ]),
                      _hoisted_12
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(siteCode.value), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(siteName.value), 1)
                        ]),
                        _createTextVNode(" で間違いありませんか？"),
                        _hoisted_17,
                        _createTextVNode(" 異なる場合は会場識別コードを再確認の上、「戻る」を押して再度入力してください。"),
                        _hoisted_18,
                        _createTextVNode(" あっている場合は「ログイン画面を表示する」を押してください。"),
                        _hoisted_19
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "m-btn primary is-center",
                        onClick: onLogin
                      }, _hoisted_21),
                      _createElementVNode("button", {
                        type: "button",
                        class: "m-btn secondary is-center",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (confirm.value = false))
                      }, _hoisted_23)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}
}

})